import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorResponse } from 'src/app/models/error.model';
import { ServicioContratado } from 'src/app/models/servicio-contratado.model';
import { Zona } from 'src/app/models/zona.model';
import { ServiciosContratadosService } from 'src/app/services/servicios-contratados.service';
import { ZonasService } from 'src/app/services/zonas.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
    selector: 'app-edit-servicio-contratado',
    templateUrl: './edit-servicio-contratado.component.html',
    styleUrls: ['./edit-servicio-contratado.component.scss']
})
export class EditServicioContratadoComponent implements OnInit {

    servicio?: ServicioContratado;
    zonas: Zona[] = [];

    form = new UntypedFormGroup({
        nombre: new UntypedFormControl('', [Validators.required]),
        codigo: new UntypedFormControl('', [Validators.required]),
        base: new UntypedFormControl('ALQUILER', [Validators.required]),
        variable: new UntypedFormControl(null, [Validators.required]),
        minPorMes: new UntypedFormControl(null, [Validators.required]),
        maxPorMes: new UntypedFormControl(null, [Validators.required]),
        pricingFijo: new UntypedFormControl(null, [Validators.required]),
        tipoProducto: new UntypedFormControl('VIVIENDA', [Validators.required]),
        idZona: new UntypedFormControl(null),
        activo: new UntypedFormControl(true, [Validators.required])
    });

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private serviciosService: ServiciosContratadosService,
        private zonasService: ZonasService,
        private utilsService: UtilsService
    ) { }

    ngOnInit(): void {
        this.loadZonas();
        this.route.params.subscribe(params => {
            if (params?.id) {
                this.serviciosService.getServicioContratadoById(params.id).subscribe({
                    next: servicio => {
                        this.servicio = servicio;
                        this.form.setValue({
                            nombre: servicio.nombre,
                            codigo: servicio.codigo,
                            base: servicio.base,
                            variable: servicio.variable,
                            minPorMes: servicio.minPorMes,
                            maxPorMes: servicio.maxPorMes,
                            pricingFijo: servicio.pricingFijo,
                            tipoProducto: servicio.tipoProducto,
                            idZona: servicio.idZona ?? null,
                            activo: servicio.activo
                        });
                    },
                    error: (error: ErrorResponse) => this.utilsService.alert('Error al obtener el servicio', error.error?.descripcion)
                });
            }
        });
    }

    loadZonas() {
        this.zonasService.getZonas(0, 200, [], { 'ocultar-inactivos': 'false' }).subscribe({
            next: response => { this.zonas = response.body ?? []; }
        });
    }

    get zonaLabel(): string {
        const id = this.servicio?.idZona;
        if (!id) return 'Default';
        return this.zonas.find(z => z.id === id)?.nombre ?? `Zona ${id}`;
    }

    save() {
        if (!this.form.valid) {
            this.form.markAllAsTouched();
            return;
        }
        const v = this.form.value;
        const payload: ServicioContratado = {
            nombre: v.nombre,
            codigo: v.codigo.toUpperCase(),
            base: v.base,
            variable: v.variable,
            minPorMes: v.minPorMes,
            maxPorMes: v.maxPorMes,
            pricingFijo: v.pricingFijo,
            tipoProducto: v.tipoProducto,
            idZona: v.idZona || null,
            activo: v.activo
        };
        if (this.servicio) {
            this.serviciosService.updateServicioContratado({ ...payload, id: this.servicio.id }).subscribe({
                next: () => {
                    this.utilsService.alert('Servicio actualizado', `"${payload.nombre}" fue actualizado correctamente.`);
                    this.navigateBack();
                },
                error: (error: ErrorResponse) => this.utilsService.alert('Error al actualizar', error.error?.descripcion)
            });
        } else {
            this.serviciosService.createServicioContratado(payload).subscribe({
                next: () => {
                    this.utilsService.alert('Servicio creado', `"${payload.nombre}" fue creado correctamente.`);
                    this.navigateBack();
                },
                error: (error: ErrorResponse) => this.utilsService.alert('Error al crear', error.error?.descripcion)
            });
        }
    }

    cancel() {
        this.navigateBack();
    }

    private navigateBack() {
        this.router.navigate(['configuracion', 'calculadora', 'servicios-contratados']);
    }
}
